"use client";
import { Box } from "@mui/material";
import React from "react";

export const GetAppButton = () => {
  const scrollToSection = (name: any) => {
    const element = document.getElementById(name);
    if (element) {
      const navbarElement = document.querySelector(".navbar-scroller");
      if (navbarElement instanceof HTMLElement) {
        const navbarHeight = navbarElement.offsetHeight || 0;
        window.scrollTo({
          top: element.offsetTop - navbarHeight,
          behavior: "smooth",
        });
      }
    }
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 85,
        right: 20,
        background: "none",
        width: "auto",
        height: "auto",
        zIndex: 1000,
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        display: { xs: "none", sm: "block" },
      }}
      onClick={() => scrollToSection("get-app-scroll")}
    >
      <Box
        sx={{
          background: "#000",
          color: "white",
          borderRadius: "5rem",
          padding: "8px 16px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontSize: "1.1rem",
          fontWeight: "bold",
        }}
      >
        Get App
      </Box>
    </Box>
  );
};
